export default class BreadCrumbItem {
  constructor ({ dimension, filter, text }) {
    this.dimension = dimension
    this.text = text
    this.filter = filter
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/BreadCrumbItem.js